<template>
    <div id="Checkout" :class="{active:getCheckoutStep > 1, overlay: getShowCart}" @click="toggleCart()">
        <div class="head">
            <p :class="{current: getCheckoutStep === 2, past: getCheckoutStep > 2}" v-if="!getMember.ID">
                <span v-if="getCheckoutStep > 2" @click="setCheckoutStep(2)"><i class="fal fa-check-circle"></i> Confirm Order</span>
                <span v-else>1. Confirm Order</span>
            </p>
            <p :class="{current: getCheckoutStep === 3, past: getCheckoutStep > 3}">
                <span v-if="getCheckoutStep > 3" @click="setCheckoutStep(3)"><i class="fal fa-check-circle"></i> Shipping Options</span>
                <span v-else>2. Shipping Options</span>

            </p>
            <p :class="{current: getCheckoutStep === 4, past: getCheckoutStep > 4}">
                <span v-if="getCheckoutStep > 4" @click="setCheckoutStep(4)"><i class="fal fa-check-circle"></i> Payment</span>
                <span v-else>3. Payment</span>
            </p>
        </div>
        <div class="body hidden-scroll">
            <p class="heading">Checkout</p>
            <p class="btn-icon" @click="toggleShowCart"><i class="fal fa-long-arrow-right"></i>Continue Shopping</p>
            <hr>
            <CheckoutLogin/>
            <CheckoutShipping/>
            <CheckoutPayment/>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import CheckoutLogin from "./CheckoutLogin";
    import CheckoutShipping from "./CheckoutShipping";
    import CheckoutPayment from "./CheckoutPayment";

    export default {
        name: "Checkout",
        components: {
            CheckoutLogin,
            CheckoutShipping,
            CheckoutPayment,
        },
        computed: {
            ...mapGetters(['getCheckoutStep', 'getShowCart', 'getMember'])
        },
        methods: {
            ...mapActions(['toggleShowCart', 'setCheckoutStep']),
            toggleCart() {
                if (this.getCheckoutStep === 1) {
                    this.toggleShowCart();
                }
            }
        },
    }
</script>
